import { Component } from "react";

import PropTypes from "prop-types";

import { Button, Stack, Typography } from "@mui/material";

// A render error otherwise leaves a blank white page with no way forward.
// This tells the person what happened in plain words and offers the one thing
// that usually helps: reloading.
export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled render error:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return <ErrorFallback />;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export const ErrorFallback = () => (
  <Stack
    role="alert"
    sx={{
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      textAlign: "center",
      gap: 2,
      px: 3,
    }}
  >
    <Typography variant="h5">Terjadi kesalahan pada halaman ini</Typography>
    <Typography color="text.secondary" sx={{ maxWidth: 480 }}>
      Halaman tidak dapat ditampilkan. Muat ulang halaman untuk mencoba lagi.
      Jika masih terjadi, hubungi admin.
    </Typography>
    <Stack direction="row" gap={1}>
      <Button variant="contained" onClick={() => window.location.reload()}>
        Muat Ulang
      </Button>
      <Button variant="outlined" onClick={() => window.location.assign("/")}>
        Ke Beranda
      </Button>
    </Stack>
  </Stack>
);
